/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type categoryPage_category$ref: FragmentReference;
export type categoryPage_category = {|
  +slug: ?string,
  +name: ?string,
  +color: ?string,
  +picture: ?string,
  +subcategories: $ReadOnlyArray<{|
    +slug: ?string,
    +name: ?string,
    +articles: $ReadOnlyArray<{|
      +slug: ?string,
      +title: ?string,
      +caption: ?string,
      +readingTime: ?number,
      +picture: ?string,
      +author: ?{|
        +firstname: ?string,
        +lastname: ?string,
      |},
      +category: ?{|
        +slug: ?string,
        +name: ?string,
      |},
    |}>,
  |}>,
  +seo: ?{|
    +title: ?string,
    +description: ?string,
  |},
  +social: ?{|
    +twitter: ?$ReadOnlyArray<?{|
      +type: ?string,
      +title: ?string,
      +image: ?string,
      +handle: ?string,
      +description: ?string,
    |}>,
    +generic: ?$ReadOnlyArray<?{|
      +title: ?string,
      +description: ?string,
      +image: ?string,
    |}>,
  |},
  +articles: $ReadOnlyArray<{|
    +slug: ?string,
    +title: ?string,
    +caption: ?string,
    +readingTime: ?number,
    +picture: ?string,
    +author: ?{|
      +firstname: ?string,
      +lastname: ?string,
    |},
    +category: ?{|
      +slug: ?string,
      +name: ?string,
    |},
  |}>,
  +$refType: categoryPage_category$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "articles",
  "storageKey": "articles(first:60)",
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 60,
      "type": "Int"
    }
  ],
  "concreteType": "Article",
  "plural": true,
  "selections": [
    v0,
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "caption",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "readingTime",
      "args": null,
      "storageKey": null
    },
    v2,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "author",
      "storageKey": null,
      "args": null,
      "concreteType": "Author",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "firstname",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "lastname",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "category",
      "storageKey": null,
      "args": null,
      "concreteType": "Category",
      "plural": false,
      "selections": [
        v0,
        v1
      ]
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "categoryPage_category",
  "type": "Category",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "color",
      "args": null,
      "storageKey": null
    },
    v2,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "subcategories",
      "storageKey": null,
      "args": null,
      "concreteType": "Category",
      "plural": true,
      "selections": [
        v0,
        v1,
        v4
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seo",
      "storageKey": null,
      "args": null,
      "concreteType": "SEO",
      "plural": false,
      "selections": [
        v3,
        v5
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "social",
      "storageKey": null,
      "args": null,
      "concreteType": "SocialMedia",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "twitter",
          "storageKey": null,
          "args": null,
          "concreteType": "TwtrSlices",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "type",
              "args": null,
              "storageKey": null
            },
            v3,
            v6,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "handle",
              "args": null,
              "storageKey": null
            },
            v5
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "generic",
          "storageKey": null,
          "args": null,
          "concreteType": "GenSocialSlices",
          "plural": true,
          "selections": [
            v3,
            v5,
            v6
          ]
        }
      ]
    },
    v4
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '18ed1013ee2c4d5cf4687c57dbf6c7cf';
module.exports = node;
